import React from 'react';

interface RichTextProps {
    className?: string;
    inline?: boolean;
    text: string;
    onClick?: (e) => void;
}

const RichText = ({ className, inline, text, onClick }: RichTextProps) => {
    const richText = { __html: text };

    const CustomTag = inline ? 'span' : 'div';
    return (
        <CustomTag onClick={onClick} className={`${className}`} dangerouslySetInnerHTML={richText} />
    );
};

RichText.defaultProps = {
    className: '',
    inline: true,
};

export default RichText;
